import { database } from '../../components/shared/database'
import { processQuerySnapshot } from '../../components/shared/process-query-snapshot'

interface OilHistoryRecord {
    deviceUid: string
    createdAt: number
    [key: string]: unknown
}

/**
 * Listen device oil history from database
 *
 * @param {string} deviceUid
 * @param {number|null} timestampFrom
 * @param {number|null} timestampTo
 * @return {Promise}
 */
export const readDeviceOilHistory = (
    deviceUid: string,
    timestampFrom: number | null = null,
    timestampTo: number | null = null,
): Promise<OilHistoryRecord[]> => {
    let resolvedFrom = timestampFrom
    if (!resolvedFrom) {
        const now = new Date()
        resolvedFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()
    }

    return database('device_oil_history')
        .where('deviceUid', '==', deviceUid)
        .where('createdAt', '>=', Number(resolvedFrom))
        .where('createdAt', '<=', Number(timestampTo || (new Date()).getTime()))
        .orderBy('createdAt', 'desc')
        .get()
        .then(processQuerySnapshot) as Promise<OilHistoryRecord[]>
}
